const saleRepresntative = [
  {
    id: "sl",
    name: "Cindy Castro",
    location: "Salt Lake, UT",
    lat: "40.770447000000004",
    lng: "-111.89254654767032",
    email: "cindyc@carstro.com",
    hours: "8:00am - 5:00pm",
    phone: "385-354-1824",
    address: "50 N Temple. 84150",
    position: "General Manager",
    image: "/salesRepresentatives/cindy.jpeg",
  },

  {
    id: "rx",
    name: "Andres Castro",
    location: "Jackson, WY",
    lat: "43.82465852358263",
    lng: "-111.78084611892702",
    email: "andresc@carstro.com",
    hours: "8:00am - 5:00pm",
    phone: "307-777-6397",
    address: "80 Scott Ln. 83002",
    position: "Sales Manager",
    image: "/salesRepresentatives/andres.jpg",
  },

  {
    id: "dv",
    name: "Kevin Castro",
    location: "Austin, TX",
    lat: "39.7392364",
    lng: "-104.984862",
    email: "kevinc@carstro.com",
    hours: "8:00am - 5:00pm",
    phone: "210-543-8397",
    address: "1100 Congress Ave. 78701",
    position: "Service Manager",
    image: "/salesRepresentatives/kevin.jpg",
  },

  {
    id: "la",
    name: "Ignacio Villar",
    location: "Los Angeles, CA",
    lat: "34.0536909",
    lng: "-118.242766",
    email: "ignaciov@carstro.com",
    hours: "8:00am - 5:00pm",
    phone: "310-398-2874",
    address: "5711 W Century Blvd. 90045",
    position: "Finance Manager",
    image: "/salesRepresentatives/ignacio.jpg",
  },
];

export { saleRepresntative };
